import { PAGES } from 'data/page-data';

export default ({ excludes = [] } = {}) => {
    if (!excludes.length) return PAGES;

    return PAGES.filter((page) => !excludes.find((id) => id === page.name.toLowerCase()));
};

export const getRoute = (id) => {
    return PAGES.find((page) => id === page.name).path;
};
